export const TEST_ID = 'errorIcon';
